import React, { useContext, useEffect } from 'react';

import { BoomiContext } from '../../contexts/BoomiContext';
import environment from 'environment';

import Card from '../../controls/Card';
import Message from '../../controls/Message';
import Button from '../../controls/Button';

import { FaTimesCircle } from 'react-icons/fa';

const reportNames = {
  wcr: 'Well Completion Report',
  war: 'Well Abandonment Report',
  hfacr: 'Hydraulic Fracturing Activities Completion Report',
};

const Home = ({ wellName, reportName }) => {
  const { boomiResponse, boomiLoading, boomiError, triggerBoomi } = useContext(BoomiContext);

  useEffect(async () => {
    if (wellName && reportName) {
      await triggerBoomi({ params: { wellName, reportName } });
    }
  }, [wellName, reportName]);

  return (
    <div className="flex flex-col items-center p-4 space-y-4">
      {(!wellName || !reportName) && <Message level="error">WellName or ReportName not provided. Please check the URL</Message>}
      {wellName && reportName && boomiLoading && (
        <Message level="loading">
          Generating {reportNames[reportName.toLowerCase()]} for {wellName}
        </Message>
      )}
      {wellName && reportName && boomiResponse && boomiResponse.message === 'Success' && (
        <Message level="success">
          <div className="flex flex-col items-center space-y-10">
            <p>
              {reportNames[reportName.toLowerCase()]} generated successfully for {wellName}
            </p>
            <a
              className="bg-primary-500 text-white text-sm uppercase px-4 py-2 hover:bg-primary-400 cursor-pointer focus:outline-none disabled:opacity-50"
              href={environment.spUrl}
            >
              Sharepoint Site
            </a>
          </div>
        </Message>
      )}
      {wellName && reportName && boomiError && (
        <Message level="success">Something went wrong while generating report for {wellName}</Message>
      )}
    </div>
  );
};

export default Home;
